import mutations from "@/store/mutations/settingMutation";
import getters from "@/store/getters/settingGetter";
import actions from "@/store/actions/settingActions";
/**
 *  mask
 */

export default {
  state: {
    settingData: {},
    isShowMoringNotification: true,
    isShowEveningNotification: true,
    launchConfig: null,
    offer_id: 'offer.id.autovip0'
  },
  mutations: mutations,
  getters: getters,
  actions: actions
};